<template>
<picker-dialog ref="dialog" :dialog-props="{'max-width': '640px'}">
  <template #default="{cancel, submit}">
    <v-card>
      <v-card-title>
        Create A New Filter Below
      </v-card-title>
      <v-tabs vertical v-model="type">
        <v-tab href="#year">Year</v-tab>
        <v-tab href="#person">Person</v-tab>
        <v-tab href="#rating">Rating</v-tab>
        <v-tab href="#tag">Tag</v-tab>
        <v-tab href="#owner">Owner</v-tab>
        <v-tab-item value="year" eager>
          <year-filter-builder ref="year" />
        </v-tab-item>
        <v-tab-item value="person" eager>
          <person-filter-builder ref="person" />
        </v-tab-item>
        <v-tab-item value="rating" eager>
          <rating-filter-builder ref="rating" />
        </v-tab-item>
        <v-tab-item value="tag" eager>
          <tag-filter-builder ref="tag" />
        </v-tab-item>
        <v-tab-item value="owner" eager>
          <owner-filter-builder ref="owner" />
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-spacer />
        <v-checkbox v-model="negate" label="NEGATE" />
        <v-spacer />
        <v-btn
          text
          color="darken-1"
          @click="cancel"
        >Cancel</v-btn>
        <v-btn
          text
          color="success darken-1"
          @click="add(submit)"
        >{{ negate ? "Exclude" : "Include" }}</v-btn>
      </v-card-actions>
    </v-card>
  </template>
</picker-dialog>
</template>

<script>
import PickerDialog from "@/components/search/dialogs/PickerDialog"
import YearFilterBuilder from "@/components/search/builders/YearFilterBuilder"
import PersonFilterBuilder from "@/components/search/builders/PersonFilterBuilder"
import RatingFilterBuilder from "@/components/search/builders/RatingFilterBuilder"
import TagFilterBuilder from "@/components/search/builders/TagFilterBuilder"
import OwnerFilterBuilder from "@/components/search/builders/OwnerFilterBuilder"

export default {
  name: "FilterPicker",
  components: {
    PickerDialog,
    YearFilterBuilder,
    PersonFilterBuilder,
    RatingFilterBuilder,
    TagFilterBuilder,
    OwnerFilterBuilder,
  },
  data() {
    return {
      type: "year",
      negate: false,
    }
  },
  inject: ["snackbar"],
  methods: {
    pop() {
      this.negate = false
      return this.$refs.dialog.pop()
    },
    add(submit) {
      const [filter, error] = this.$refs[this.type].build(this.negate)
      if (filter) {
        submit(`that are ${filter} `)
      } else if (error) {
        this.snackbar(error)
      }
    },
  },
  watch: {
    type(val) {
      this.$refs[val].init()
    },
  },
}
</script>
